<template>
  <el-dialog title="新增图文文章" :visible.sync="visible" width="50%" :close-on-click-modal="false">
    <el-form :model="data" :rules="rules" ref="addForm" label-width="90px">
      <el-form-item label="公告标题:" prop="name">
        <el-input type="text"  :maxlength="30" v-model="data.name" placeholder="请填写，最多20字" clearable />
      </el-form-item>
      <el-form-item class="uEditor" label="公告详情:" prop="detail">
        <UEditor v-model="data.content"></UEditor>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="confirm">确认</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState } from 'vuex'
import UEditor from '@/components/UEditor'
import FileUpload from "@/views/crm/components/fileUpload";

export default {
  name: "AddClueDialog",
  components: {
    UEditor,
    FileUpload
  },
  props: {
  },
  data() {
    return {
      visible: false,
      typeList: [{
          id: 1,
          name: '图文'
      },{
          id: 2,
          name: '视频'
      }],
      rules: {
        name: [
          {required: true, message: '请输入公告标题', trigger: 'change'}
        ],
        detail:  [
          {required: true, message: '请输入公告内容', trigger: 'change'}
        ]
      },
      data: {
        name: null,
        detail: null
      }
    };
  },
  computed: {
    ...mapState({
      currentUserId: state => state.user.userId
    })
  },
  watch: {
    visible (val) {
      if (!val) {
        this.data.companyId = null
        this.resetForm("addForm");
      }
    }
  },
  methods: {
    open () {
      this.visible = true
    },
    handleFileChange (fileObjs) {
      this.data.fileObjs = fileObjs;
    },
    confirm () {
      this.$refs['addForm'].validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '加载中',
            spinner: 'el-icon-loading'
          });
          addClue(this.data).then(response => {
            this.$emit('success')
            this.visible = false
            loading.close();
            this.msgSuccess("销售线索创建成功");
          }).catch(error => {
            loading.close()
          })
        } else {
          this.msgWarning("请检查必填项");
          return false;
        }
      });
    }
  }
};
</script>
